import employService from "@/services/employ.js"
import jobofferService from "@/services/jobOffer.js"

export default {
  mounted() {
    const vue = this;
    if (vue.$route.query.locality) {
      const gm = document.getElementById("autocompletor");
      if (gm && gm.value === "") {
        gm.value = vue.$route.query.locality;
      }
    }
  },
  methods: {
    searchGenericMissions(lat, lng) {
      const vue = this;
      vue.missionsList = [];
      if ((lat != null && lat != undefined) && ((lng != null && lng != undefined))) {
        vue.loading = true;
        jobofferService.searchJobOffer({lat, lng})
          .then(function(response) {
            if (response.success) {
              vue.missionsList = response.data.records ? response.data.records : [];
              const params = {
                lat: lat,
                lng: lng,
              };
              // history.pushState(
              //   {},
              //   null,
              //   route +
              //     "?" +
              //     Object.keys(params)
              //       .map((key) => {
              //         return (
              //           encodeURIComponent(key) +
              //           "=" +
              //           encodeURIComponent(params[key])
              //         );
              //       })
              //       .join("&")
              // );
            } else {
              vue.error = true;
            }
          })
          .catch(function(error) {
            vue.error = true;
          })
          .finally(function() {
            vue.loading = false;
          });
      }
    },
  },
};
